var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 44C29.3358 41.5226 32.507 40 36 40C39.493 40 42.6642 41.5226 45 44M40.5 31.5C40.5 33.9853 38.4853 36 36 36C33.5147 36 31.5 33.9853 31.5 31.5C31.5 29.0147 33.5147 27 36 27C38.4853 27 40.5 29.0147 40.5 31.5Z",
    stroke: "#11113A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/lead.3b6fa98a66ce78fb3284d61d57156cb9.svg";
export { ForwardRef as ReactComponent };